import React from "react";
import { Message, MessageProps } from "semantic-ui-react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

import "./message-block.scss";
import {Icon} from "../icon/icon";

class MessageBlock extends React.Component<MessageProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    dismiss: string[] = [];
    constructor(props: MessageProps) {
        super(props);
        const { cookies, topic, index } = this.props;
        const cookieString = cookies.get("mv-dismiss");
        this.dismiss = cookieString? cookieString.split(";"): [];
        this.state = {
            visible: !this.dismiss.includes(topic + "_" + index)
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = (): void => {
        const { cookies, topic, index } = this.props;
        this.setState({ visible: false });
        const messageId = topic + "_" + index;
        this.dismiss.push(messageId);
        cookies.set("mv-dismiss", this.dismiss.join(";"), { path: "/", sameSite: "lax" });
    };

    render(): JSX.Element | null {
        if (this.state.visible && this.props.content) {
            let className = "geo-component";
            if (this.props.className) {
                className += " " + this.props.className;
            }
            // quick and dirty!
            const content = (
                <div>
                    <Icon onClick={this.handleDismiss} className={"close"} name="navigate_cross"
                        title={"Hinweis schliessen"} />
                    <p dangerouslySetInnerHTML={{__html: this.props.content as string}}/>
                </div>
            );
            return (
                <Message floating
                    className={className}
                    info={true}
                    header={this.props.header}
                    content={content}
                />
            );
        }

        return null;
    }
}
export default withCookies(MessageBlock);
